import {
  AliasIaIcon,
  BrandIcon,
  EditIcon,
  InformacionAdicionalIcon,
  RelevantPeopleIcon,
  ScreenTextOcrIcon,
  VideoCutsCortesIcon,
  VoiceStatementIcon,
  ValidatorClockIcon,
} from '@acceso/design-system';

import { ESegmentToolkit, TToolkit } from '../types';

const TOOLKIT: TToolkit[] = [
  {
    label: 'Cortes',
    value: ESegmentToolkit.CORTES,
    icon: props => <VideoCutsCortesIcon {...props} />,
  },
  {
    label: 'Logos',
    value: ESegmentToolkit.LOGOTIPO,
    icon: props => <BrandIcon {...props} />,
    countable: true,
  },
  {
    label: 'Personas',
    value: ESegmentToolkit.PERSONAS,
    icon: props => <RelevantPeopleIcon {...props} />,
    countable: true,
  },
  {
    label: 'Declaraciones',
    value: ESegmentToolkit.DECLARACIONES,
    icon: props => <VoiceStatementIcon {...props} />,
    countable: true,
  },
  {
    label: 'Rótulos',
    value: ESegmentToolkit.ROTULOS,
    icon: props => <ScreenTextOcrIcon {...props} />,
  },
  {
    label: 'Keywords',
    value: ESegmentToolkit.MENCIONES,
    icon: props => <AliasIaIcon {...props} />,
  },
  {
    label: 'Información',
    value: ESegmentToolkit.INFORMACION,
    icon: props => <InformacionAdicionalIcon {...props} />,
  },
];

const TOOLKIT_CLIPS: TToolkit[] = [
  {
    label: 'Editar',
    value: ESegmentToolkit.CORTES,
    icon: props => <EditIcon {...props} />,
  },
  {
    label: 'Toma de tiempos',
    value: ESegmentToolkit.TIMEKEEPING,
    icon: props => <ValidatorClockIcon {...props} />,
    countable: true,
  },
  ...TOOLKIT.filter(toolkit => toolkit.value !== ESegmentToolkit.CORTES),
];

const TOOLKIT_RADIO = TOOLKIT.filter(
  toolkit =>
    toolkit.value !== ESegmentToolkit.LOGOTIPO && toolkit.value !== ESegmentToolkit.PERSONAS
);

const TOOLKIT_CLIP_RADIO: TToolkit[] = [
  {
    label: 'Editar',
    value: ESegmentToolkit.CORTES,
    icon: props => <EditIcon {...props} />,
  },
  ...TOOLKIT_RADIO.filter(toolkit => toolkit.value !== ESegmentToolkit.CORTES),
];

const TOOLKIT_GLOBAL_VIEW: TToolkit[] = TOOLKIT.filter(
  toolkit => toolkit.value !== ESegmentToolkit.CORTES
);

export { TOOLKIT, TOOLKIT_CLIPS, TOOLKIT_RADIO, TOOLKIT_CLIP_RADIO, TOOLKIT_GLOBAL_VIEW };
